import React, { createContext, useState, useContext, useEffect, useRef } from 'react';
import { useCartMenu } from '../contexts/CartMenuContext';
const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const hasMounted = useRef(false);
  const { setIsCartOpen } = useCartMenu();
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    const savedTimeCart = localStorage.getItem('cartTimeSave');

    if (savedTimeCart) {
      const timeDifference = Date.now() - parseInt(savedTimeCart, 10);
      // If more than 31 days have passed, clear the cart
      if (timeDifference > 31 * 24 * 60 * 60 * 1000) {
        localStorage.removeItem('cartItems');
        localStorage.removeItem('cartTimeSave');
        return;
      }
    }
    else if (!savedTimeCart) {
      localStorage.removeItem('cartItems');
    }
    
    const savedCart = localStorage.getItem('cartItems');
    
    if (savedCart){
      setCartItems(JSON.parse(savedCart));
    }
  }, []);

  useEffect(() => {
    if (hasMounted.current) {
      localStorage.setItem('cartItems', JSON.stringify(cartItems));
      localStorage.setItem('cartTimeSave', Date.now().toString());  
    } else {
      hasMounted.current = true;
    }
  }, [cartItems]);

  const addToCart = (product) => {
    setCartItems((prevItems) => [...prevItems, product]);
    setIsCartOpen(true);
  };

  const removeFromCart = (productId) => {
    setCartItems((prevItems) => prevItems.filter(item => item.id !== productId));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const increaseItemQuantity = (itemId) => {
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.id === itemId ? { ...item, numberOfItems: item.numberOfItems + 1 } : item
      )
    );
  };
  
  const decreaseItemQuantity = (itemId) => {
    setCartItems(prevItems =>
      prevItems.map(item =>
        item.id === itemId && item.numberOfItems > 1
          ? { ...item, numberOfItems: item.numberOfItems - 1 }
          : item
      )
    );
  };
  

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart, increaseItemQuantity, decreaseItemQuantity }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  return useContext(CartContext);
};
